import { KycCompletionStatus } from '~/store/business-types';
import { currencyUtils } from '~/utils/currency.utils';
export const kycWarningTextsPath = 'pages.dashboard.kycWarning';
export const externalAccountWarningTextsPath = 'pages.dashboard.externalAccountWarning';
export function getKycWarning(worksAt, wasKYBApprovedDuringLast5Minutes, kycWarningTexts) {
    const { kycCompletionStatus } = worksAt || {};
    if (kycCompletionStatus === KycCompletionStatus.CompletedWithFutureRequirements) {
        return {
            testId: 'kyc-future-requirements',
            text: kycWarningTexts.message()
        };
    } else if (kycCompletionStatus === KycCompletionStatus.Incomplete && !wasKYBApprovedDuringLast5Minutes) {
        return {
            testId: 'onboarding-kyc-error',
            text: kycWarningTexts.message()
        };
    } else {
        return null;
    }
}
export function getExternalAccountWarning(worksAt, externalAccountWarningTexts) {
    var _externalAccountStatus_bankLast4, _externalAccountStatus_bankName, _externalAccountStatus_deficitAmount;
    var _worksAt_stripe;
    const externalAccountStatus = (_worksAt_stripe = worksAt.stripe) === null || _worksAt_stripe === void 0 ? void 0 : _worksAt_stripe.externalAccountStatus;
    if ((externalAccountStatus === null || externalAccountStatus === void 0 ? void 0 : externalAccountStatus.status) !== 'errored') return null;
    const last4 = (_externalAccountStatus_bankLast4 = externalAccountStatus.bankLast4) !== null && _externalAccountStatus_bankLast4 !== void 0 ? _externalAccountStatus_bankLast4 : '';
    const bankName = (_externalAccountStatus_bankName = externalAccountStatus.bankName) !== null && _externalAccountStatus_bankName !== void 0 ? _externalAccountStatus_bankName : '';
    const hasBankName = bankName ? 'yes' : 'no';
    const testId = 'external-account-errored-warning';
    if (externalAccountStatus.reason === 'payoutsBlocked') {
        return {
            testId,
            text: externalAccountWarningTexts.blockedMessage({
                hasBankName,
                bankName,
                last4
            })
        };
    }
    const amountCents = (_externalAccountStatus_deficitAmount = externalAccountStatus.deficitAmount) !== null && _externalAccountStatus_deficitAmount !== void 0 ? _externalAccountStatus_deficitAmount : 0;
    const amount = currencyUtils.formatDollarAmount(currencyUtils.centsToDollars(amountCents));
    return {
        testId,
        text: externalAccountWarningTexts.deficitMessage({
            amount,
            hasBankName,
            bankName,
            last4
        })
    };
}
